import { render, staticRenderFns } from "./NoDropBox.vue?vue&type=template&id=f29e5140&lang=pug&"
import script from "./NoDropBox.vue?vue&type=script&lang=js&"
export * from "./NoDropBox.vue?vue&type=script&lang=js&"
import style0 from "./NoDropBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports